/* import __COLOCATED_TEMPLATE__ from './sections.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();